/**
 * @generated SignedSource<<9f25470e51da80e6750dd1882868cfe2>>
 * @relayHash d52e66d12a0624aac2fdbfe49ab48ab1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c1dd07ac639cb5bde54983be5bcee1631624741f1f5249dd51307802eefc42d

import type { ConcreteRequest } from 'relay-runtime';
export type preloadOutboundBylineSsrStateQuery$variables = {
  contentId: string;
};
export type preloadOutboundBylineSsrStateQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly outgoingLinks: {
        readonly externalOutgoingLinks: {
          readonly nodes: ReadonlyArray<{
            readonly url: string | null;
          } | null> | null;
        } | null;
        readonly internalOutgoingLinks: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly links: {
              readonly base: string | null;
              readonly webui: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};
export type preloadOutboundBylineSsrStateQuery = {
  response: preloadOutboundBylineSsrStateQuery$data;
  variables: preloadOutboundBylineSsrStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "OutgoingLinks",
            "kind": "LinkedField",
            "name": "outgoingLinks",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "ConfluenceExternalLinkConnection",
                "kind": "LinkedField",
                "name": "externalOutgoingLinks",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceExternalLink",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      }
                    ]
                  }
                ],
                "storageKey": "externalOutgoingLinks(first:3)"
              },
              {
                "args": (v2/*: any*/),
                "concreteType": "PaginatedContentList",
                "kind": "LinkedField",
                "name": "internalOutgoingLinks",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "base"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "webui"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "internalOutgoingLinks(first:3)"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadOutboundBylineSsrStateQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadOutboundBylineSsrStateQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d52e66d12a0624aac2fdbfe49ab48ab1",
    "id": "8c1dd07ac639cb5bde54983be5bcee1631624741f1f5249dd51307802eefc42d",
    "metadata": {},
    "name": "preloadOutboundBylineSsrStateQuery",
    "operationKind": "query",
    "text": "query preloadOutboundBylineSsrStateQuery($contentId:ID!){content(id:$contentId){nodes{id,outgoingLinks{externalOutgoingLinks(first:3){nodes{url}},internalOutgoingLinks(first:3){nodes{id,links{base,webui}}}}}}}"
  }
};
})();

(node as any).hash = "aadfb15d662296b74dd0622642b547bf";

export default node;
